<template>
  <section>
    <section class="mx-4 mt-20 md:mx-auto md:w-11/12 md:max-w-[1216px]" data-testid="recently-viewed-section">
      <h3 id="recently-viewed" class="mb-5 ml-0 flex scroll-mt-20 font-Spectral text-xl tracking-wide text-gold4 md:mb-4 md:text-[30px] md:leading-[40px]">
        Recently Viewed
        <span class="mx-2 flex flex-grow items-center">
          <span class="h-[0.5px] flex-grow bg-gold4"></span>
        </span>
      </h3>
      <MoleculesHorizontalScrollWrapper scroll-button-box-style="h-[157px] md:h-[228px]">
        <div v-for="(experience, i) in experiences" :key="i + experience.id" :class="[i === 0 ? 'ml-0' : '']">
          <OrganismsPagesEnExperienceCard
            :key="experience.id"
            class="mb-2 w-[280px] overflow-hidden md:w-[360px]"
            orientation="horizontal"
            theme="dark"
            :disable-carousel-on-sp="true"
            :display-multiple-images="false"
            :experience="experience"
            :on-experience-click="(experienceSlug) => handleExperienceClick('recently-viewed', experienceSlug)"
          />
        </div>
      </MoleculesHorizontalScrollWrapper>
    </section>
  </section>
</template>

<script lang="ts" setup>
import MoleculesHorizontalScrollWrapper from '@/components/molecules/HorizontalScrollWrapper/HorizontalScrollWrapper.vue';
import OrganismsPagesEnExperienceCard from '@/components/organisms/pages/en/experienceCard/EnExperienceCard.vue';
import type { WabunkaExperienceListViewModel } from '@/models/wabunka/wabunkaExperience';

interface Props {
  experiences: WabunkaExperienceListViewModel;
  onExperienceClick?: (sectionId: string, experienceSlug: string) => void;
}

const props = defineProps<Props>();

const handleExperienceClick = (sectionId: string, experienceSlug: string) => {
  if (props.onExperienceClick) {
    props.onExperienceClick(sectionId, experienceSlug);
  }
};
</script>
